import { useChargesEnabledLocations } from '@frontend/person-invoice-create';
import { ButtonProps, useModalControl, useTooltip } from '@frontend/design-system';

export type UsePaymentsModalButtonOptions = { locationIds?: string[]; personId?: string };
export type UsePaymentsModalButtonReturnType = ReturnType<typeof usePaymentsModalButton>;
const defaultObj = {};

export const usePaymentsModalButton = ({ locationIds, personId }: UsePaymentsModalButtonOptions = {}) => {
  const { disabledMessage, getDisabledMessage } = useChargesEnabledLocations({
    locationIds,
    personId,
  });
  const disabled = !!disabledMessage;

  const { modalProps, triggerProps: modalTriggerProps, openModal, closeModal } = useModalControl();
  const { Tooltip, tooltipProps, triggerProps: errorTooltipTriggerProps } = useTooltip();

  const tooltip = <>{disabledMessage && <Tooltip {...tooltipProps}>{disabledMessage}</Tooltip>}</>;
  const tooltipTriggerProps = disabled ? errorTooltipTriggerProps : defaultObj;

  const handleClick = () => {
    modalTriggerProps.onClick();
  };

  return {
    tooltipTriggerProps,
    openModal,
    closeModal,
    hidePaymentRequestModal: disabled,
    disabled,
    disabledMessage,
    modalProps,
    Tooltip: tooltip,
    triggerProps: {
      disabled,
      ...modalTriggerProps,
      ...tooltipTriggerProps,
      onClick: handleClick,
    } satisfies ButtonProps,
    paymentRequestModalProps: {
      ...modalProps,
      Tooltip: tooltip,
    },
    disabledButtonProps: {
      disabled,
      hoverLabel: disabledMessage,
      showLabelWhenDisabled: disabled,
    } satisfies ButtonProps,
    getDisabledMessage,
  };
};
